import classNames from 'classnames';

import { Skeleton } from '../skeleton';
import Typography, { TypographyProps } from '../typography/typography';

export interface DTProps extends TypographyProps {
  className?: string;
  emptyValue?: string | number;
  isEmpty?: boolean;
  loading?: boolean;
}

/**
 * Description terms element (dt) provided as a component enhanced with more options based on the Typography component
 */
export function DT({
  children,
  className,
  emptyValue = '-',
  isEmpty = false,
  loading = false,
  ...TypographyProps
}: React.PropsWithChildren<DTProps>) {
  return (
    <Typography variant="dt" variantComponent="dt" {...TypographyProps} className={classNames(className)}>
      {loading && <Skeleton variant="text" />}

      {!loading && (isEmpty ? emptyValue : children)}
    </Typography>
  );
}

export default DT;
